import React, { useMemo, useContext, useRef } from 'react';
import { SurveyContext } from '@bingads-webui-campaign-react/survey-context';
import { TextField } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { CommentData, I18n } from '../../../survey.types';
import { QuestionTitle } from './title';
import { SurveyContextType } from '../../../survey-context';
import { getDescription, ErrorString } from './common';

interface CommentViewProps {
  data: CommentData;
  configurator: any;
  setData: any;
  dirtyState: any;
  setDirtyState: any;
}

export const CommentView = (props: CommentViewProps) => {
  const {
    configurator,
    data,
    setData,
    dirtyState,
    setDirtyState,
  } = props;

  // @ts-ignore
  const surveyContext: SurveyContextType = useContext(SurveyContext);

  const {
    getSurveyAnswers,
    logActivity,
  } = surveyContext;

  const answers = getSurveyAnswers();

  const title = useMemo(() => configurator.getTitle(answers), [answers, configurator]);
  const i18n: I18n = useContext(I18nContext);

  const {
    input,
  } = data;

  const titleError = useMemo(() => configurator.isAnswered(data), [configurator, data]);
  const commentError = useMemo(() => configurator.getError(data), [configurator, data]);
  const {
    maxLength,
    placeholder,
  } = configurator.getConfiguration();

  const isDirty = dirtyState;
  const logged = useRef(false);

  return (
    <div className="comment" >
      <QuestionTitle isDirty={isDirty} configurator={configurator} error={titleError} >
        <TextField
          styles={{
            root: {
              '& .ms-TextField-description': {
                marginTop: '4px',
                display: 'block',
                textAlign: 'right',
                fontSize: 'inherit',
                color: 'inherit',
              },
              '& .ms-TextField-fieldGroup': {
                borderColor: (isDirty && commentError) ? '#A80000' : undefined,
              },
              paddingBottom: '8px',
            },
          }}
          ariaLabel={title}
          multiline
          rows={3}
          resizable={false}
          placeholder={placeholder || i18n.getString(_TL_('Please do not include any confidential or personal information in your feedback.'))}
          value={input}
          onChange={(e, value) => {
            setDirtyState(true);
            setData({ input: value });
            if (logged.current === false) {
              logActivity(`Question: ${configurator.key}, type: comment, action: input`);
              logged.current = true;
            }
          }}
          description={maxLength != null ? getDescription(input, maxLength, i18n) : undefined}
        />
        {isDirty && commentError && <ErrorString error={commentError} />}
      </QuestionTitle>
    </div>
  );
};
